import { render, staticRenderFns } from "./AppointmentLegend.vue?vue&type=template&id=b5dca4de&"
import script from "./AppointmentLegend.vue?vue&type=script&lang=js&"
export * from "./AppointmentLegend.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentLegend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports